import * as THREE from 'three';
import * as marietta from '../../../../marietta';
import { Loader, ObjectType } from './Loader';
import { attribute } from '../UtilityInfo';
import { OBBManager } from '../OBBManager';

/* tslint:disable:no-any */
export class ObjectLoader {

    constructor() {}

    private transformObject(object: THREE.Group, data: marietta.view3d.webcad.ModelInfo): THREE.Group {
        object.position.set(data.translateX, data.translateY, data.translateZ);
        object.scale.set(data.scaleX, data.scaleY, data.scaleZ);
        object.rotation.set(data.rotationX, data.rotationY, data.rotationZ);
        return object;
    }

    public loadASync(modelinfo: marietta.view3d.webcad.ModelInfo, alternative?: any): Promise<THREE.Group|void> {
        // モデルの読み込み
        if (marietta.webcad.WebCADGlobal != undefined) marietta.webcad.WebCADGlobal.showBusy(marietta.webcad.collection.WebCADMessages.getText('BUSY_LOADING_3D_OBJECT'));

        const onLoad = (object: any): THREE.Group => {
            if (marietta.webcad.WebCADGlobal != undefined) marietta.webcad.WebCADGlobal.hideBusyStrict();

            object.scene.userData.obb = new OBBManager(object.scene);

            const object3d = this.transformObject(object.scene, modelinfo);
            // if (modelinfo.reverse) {
            //     object.scene.scale.multiply(new THREE.Vector3(-1, 1, 1));
            // }
            object.scene.userData.modelInfo = modelinfo;

            const attribute_ = new attribute();
            attribute_.alternative = alternative;
            attribute_.thumbnail = modelinfo.thumbnail;
            attribute_.objectId = modelinfo.code;
            attribute_.originalUp = object.originalUp;
            attribute_.objectName = `${modelinfo.code}.${loader.exitension()}`;

            object3d.userData.attribute = attribute_;
            object3d.userData.layer = modelinfo.layer;
            return object3d;
        };

        const url = modelinfo.url_model3d();

        // const url = modelinfo.url;
        const loader = new Loader(modelinfo.url);

        // loader.getLoader().load(modelinfo.url, onLoad, undefined, onError);
        return loader.getLoader().loadAsync(url).then((object: ObjectType): Promise<THREE.Group> => {
            return new Promise(function(fulfilled, rejected){
                fulfilled(onLoad(object))
            })
        })
        .catch((message) => {
            console.log(`not found modeldata - ${url}`);
            if (marietta.webcad.WebCADGlobal != undefined) marietta.webcad.WebCADGlobal.hideBusyStrict();
            return Promise.reject(message);
        });
    }
}
